<template>
  <div id="app">
    <headerCom ref="headerCom"></headerCom>
    <router-view></router-view> 
    <footerCom></footerCom>
    <!-- 支付 -->
    <payCom ref="payCom"></payCom>
    <el-backtop :bottom="160">
      <div class="z-flex z-flex-col z-flex-center">
        <i class="el-icon-arrow-up"></i>
        <span class="text">TOP</span>
      </div>
    </el-backtop>
  </div>
</template>

<script>
import headerCom from '@/components/headerCom'
import footerCom from '@/components/footerCom'
import payCom from '@/components/payCom'
import {mapState, mapActions} from "vuex";
import Vue from "vue";
export default {
  name: 'app',
  components:{
    headerCom,
    footerCom,
    payCom,
  },
  created() {
    this.vuexInitLocalUser();
    if (!this.$helper.isLogin()) {
      let token = this.$cookies.get("token");
      if (token) {
        this.$axios.api.getUserInfo({}, (res) => {
          if (res.code == 200) {
            let user = {
              id: res.data.id,
              avatar: res.data.avatar,
              username: res.data.nickname,
              vipName: res.data.vip_name,
              vipExpiration: res.data.limit_date,
              qtclubWinStar: res.data.qtclub_win_star,
              qtclubWinStarName: res.data.qtclub_win_star_name,
              qtclubWinPopup: res.data.qtclub_win_popup
            };
            this.vuexUserLogin(user);
            localStorage.setItem('token', token);
          }
        });
      }
    }
  },
  computed: {
    ...mapState(['vuex_user'])
  },
  methods: {
    ...mapActions(['vuexUserLogin', 'vuexUserLogout', 'vuexInitLocalUser']),
    showLogin() {
      this.$refs.headerCom.toLogin();
    },
    // 发起支付
    clickToPay(data) {
      // 判断是否登录
      if(!this.$helper.isLogin()){
        this.showLogin();
      }
      // 判断是否有优惠券
      this.$axios.api.request({
        url: "/api/qtclub/user/getChooseCoupon",
        method: "GET",
        data: {
          object: data.platform,
        }
      }, (res) => {
        if(res.data.coupon_show == true){
          this.$refs.payCom.couponList = res.data.list;
          this.$refs.payCom.payResult = 'selCoupon';
          this.$refs.payCom.payData = data;
          this.$refs.payCom.show = true;
        }else{
          this.confirmToPay(data, '');
        }
      });
    },
    // 选择套餐
    showPayCombo(){
      this.$refs.payCom.show = true;
    },
    // 确认支付
    confirmToPay(data, coupon) {
      // 创建支付订单
      this.$axios.api.request({
        url: "/addons/epay/index/create",
        method: "POST",
        data: {
          user_id: this.vuex_user.id,
          type: 'wechat',
          method: 'scan',
          recharge_type: data.recharge_type,
          combo_id: data.combo_id,
          volume: data.volume,
          amount: '',
          coupon: coupon,
          platform: data.platform,
        },
      }, (res) => {
        this.$refs.payCom.price = data.price;
        this.$refs.payCom.payCode = res.data.qr_code;
        this.$refs.payCom.show = true;
        this.checkOrderPay(res.data.out_trade_no);
      });
    },
    // 支付校验
    checkOrderPay(out_trade_no) {
      // 支付页关闭停止校验
      if(this.$refs.payCom.show == false){
        return false;
      }
      let that = this;
      this.$axios.api.request({
        url: '/addons/epay/index/wechatreturn/out_trade_no/'+out_trade_no,
        method: "GET",
      }, (res) => {
        if (res.code == 1) {
            this.$refs.payCom.payResult = 'success';
        } else {
          setTimeout(function() {
            that.checkOrderPay(out_trade_no);
          }, 3000);
        }
      });
    },
  }
}
</script>

<style lang="scss">
html,body{
  width:100%;
  height:100%;
}
body{
  font-size: 16px;
  color: $colorOpp;
}
#app{
  width:100%;
  height:100%;
}
.container{
  min-height: calc(100vh - 140px);
  padding:40px 0;
  background:#f5f5f5;
}
.wrap{
  width: 1380px;
  margin: 0 auto;
}
.el-message{
  top: 200px!important;
}
.el-image__error{
  background: #e9e9e9!important;
}
.el-dropdown-menu{
  padding:5px 0!important;
  .el-dropdown-menu__item{
    padding:0;
    .d-item{
      padding:0 20px;
    }
  }
}
.el-backtop{
  width:48px!important;
  height:48px!important;
  border-radius:4px!important;
  i{
    font-size:24px;
  }
  .text{
    font-size:12px;
    font-family:Arial,sans-serif;
  }
}
.el-popconfirm__main{
  padding: 10px 0 15px;
}
.pagination{
  text-align:center;
  margin:30px 0;
}
.my-menu{
  min-width: 0!important;
}
.box-con{
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
}
.box-item{
  margin-bottom: 20px;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  height:260px;
  cursor: pointer;
  .img-wrap{
    width: 100%;
    height:165px;
    overflow: hidden;
    .img{
      width: 100%;
      height:100%;
      object-fit: cover;
      transition: all .5s;
    }
  }
  .title{
    height: 40px;
    line-height: 20px;
    margin: 10px 10px 0;
    font-size: 16px;
    @include textOverflowNum(2);
  }
  .desc{
    margin: 12px 10px 0;
    font-size: 12px;
    color: #777;
    .desc-l{
      flex:1;
      margin-right: 10px;
      @extend %textOverflow;
    }
  }
  &:hover{
    .img{
      transform: scale(1.1);
    }
  }
  &.prize-item{
    height: 225px;
  }
}
.box-con-reco{
  width: 300px;
  .hd{
    height:50px;
    border-bottom:$border;
    .hd-l{
      font-size:16px;
      padding-left:10px;
      border-left:4px solid $colorMain;
    }
  }
}
.page-t{
  margin-bottom: 30px;
  font-size: 25px;
  height: 24px;
  line-height: 24px;
  border-left: 4px solid $colorMain;
  padding-left: 10px;
}
.page-b{
  margin-bottom: 30px;
  .item{
    font-size: 15px;
    padding: 7px 25px;
    margin: 0 10px 10px 0;
    color: $colorMain;
    background: #fbe6e9;
    border: 1px solid #f099a6;
    border-radius: 4px;
    cursor: pointer;
    &:hover{
      color: #fff;
      background: $colorMain;
      border-color: $colorMain;
    }
    &.active{
      color: #fff;
      background: $colorMain;
      border-color: $colorMain;
    }
  }
}
.my-r{
  flex: 1;
  margin-left: 15px;
  .my-box{
    margin-top: 15px;
  }
}

.download-img-msg-box{
  .el-message-box__message{
    font-size: 16px;
    .el-icon-warning{
      font-size: 35px;
      color:#909399;
      margin: 0 0 15px 0;
    }
  }
  .btn-download-filename,
  .btn-download-title{
    font-size: 14px;
    padding: 10px 25px;
  }
}
// @media screen and (max-width:1400px){
//   .wrap{
//     width: 1000px;
//   }
// }
// @media screen and (max-width:1020px){
//   .wrap{
//     width: 780px;
//   }
// }
// @media screen and (max-width:790px){
//   .wrap{
//     width: auto;
//     margin: 0 10px;
//   }
// }
</style>
